// 1. Import 'forwardRef' from React
import { ButtonHTMLAttributes, forwardRef } from 'react';

interface PrimaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {}

const PrimaryButton = forwardRef<HTMLButtonElement, PrimaryButtonProps>(
    ({ className = '', disabled, children, ...props }, ref) => {
        return (
            <button
                {...props}
                ref={ref}
                className={
                    `text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-4 py-2 duration-150 ${
                        disabled ? 'opacity-25 ' : ''
                    }` + (className || '')
                }
                disabled={disabled}
            >
                {children}
            </button>
        );
    }
);

export default PrimaryButton;
